import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { clearUserContext } from "utils/sentryHelpers";

import { registerUser, userLogin } from "./authActions";

interface AuthState {
  loading: boolean;
  userToken: string | null;
  error: string | unknown;
  success: boolean;
}

const userToken: string | null = Cookies.get("userToken") || null;

const initialState: AuthState = {
  loading: false,
  userToken,
  error: null,
  success: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      Cookies.remove("userToken");
      clearUserContext();
      state.loading = false;
      state.userToken = null;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    // userLogin Action
    builder.addCase(userLogin.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(userLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.userToken = action.payload.token;
    });
    builder.addCase(userLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // registerUser Action
    builder.addCase(registerUser.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(registerUser.fulfilled, (state, action) => {
      state.loading = false;
      state.userToken = action.payload.Token;
      state.success = true;
    });
    builder.addCase(registerUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
